import PeopleDetailHeroLeft from './PeopleDetailHeroLeft';

export { type PeopleDetailHeroLeftProps } from './PeopleDetailHeroLeft';
export default PeopleDetailHeroLeft;
